var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_layer_legend_interface = function () {
    OCS.Viewer.Interfaces.LayerLegend = {
        has_legend: true,
        legend_canvas: null,
        legend_visible: false,
        legend_id: "",
        legend_height: 10,
        legend_width: 500,
        add_legend_events: function () {
            this.addEvent('activate_layer_legend', this.on_activate_layer_legend.bind(this));
            this.addEvent('deactivate_layer_legend', this.on_deactivate_layer_legend.bind(this));
            this.addEvent('mouse_click', this.on_mouse_click.bind(this));
            this.addEvent('mouse_over', this.on_mouse_over.bind(this));
        },
        create_legend_canvas: function (container) {
            var legend_id = this.get_legend_id();
            this.set_legend_canvas(new Element('canvas', {width: this.legend_width, height: this.legend_height, 'class': "map_legend " + this.class_name + "_legend", 'id': legend_id}));
            if(!this.legend_visible) {
                this.legend_canvas.addClass('hidden');
            }
            this.legend_canvas.inject(container, 'top');
            this.create_layer_legend(this.legend_canvas);
        },
        create_layer_legend: function (canvas) {
            var palette_obj = this.get_palette();
            if (palette_obj) {
                var palette = palette_obj.get_color_curve();
                var ctx = canvas.getContext('2d');
                var grd = ctx.createLinearGradient(0, 0, this.legend_width, 0);
                var stop, color_str;
                var util = OCS.Viewer.Functions.get_utilities();
                Object.each(palette, function (a, b) {
                    stop = 0;
                    if (b !== 0 && (b < palette.length)) {
                        stop = (b / (palette.length - 1));
                    }
                    if (b >= palette.length - 1) {
                        stop = 1;
                    }
                    color_str = util.hexa2rgbaString(a);
                    grd.addColorStop(stop, color_str);
                }.bind(this));
                ctx.fillStyle = grd;
                ctx.fillRect(0, 0, this.legend_width, this.legend_height * 8);

            }
        },
        get_legend_canvas: function (container) {
            if (!this.legend_canvas && container) {
                this.create_legend_canvas(container);
            }
            return this.legend_canvas;
        },
        get_frac: function (trackLonLat) {
            var source = this.get_source_obj();
            if (source) {
                var stats = source.valueFromLonLat(trackLonLat);
                if (stats) {
                    return stats.frac;
                }
            }
            return 0;
        },
        get_legend_tooltip_text: function (trackLonLat) {
            var source = this.get_source_obj();
            if (source) {
                var stats = source.valueFromLonLat(trackLonLat);
                if (stats) {
                    var text_value;
                    if (stats.precision !== null && stats.precision !== undefined) {
                        text_value = stats.value.toFixed(stats.precision);
                    } else {
                        text_value = stats.value;
                    }
                    if (stats.unit) {
                        text_value += " " + stats.unit;
                    }
                    return text_value;
                }
            }
            return "";
        },
        get_legend_status_text: function (trackLonLat) {
            return trackLonLat[1].toFixed(3) + '&deg; N, ' + Math.abs(trackLonLat[0]).toFixed(3) + '&deg; W';
        },
        remove_legend_canvas: function () {
            if (this.legend_canvas) {
                this.legend_canvas.destroy();
                this.legend_canvas = null;
            }
        },
        set_legend_canvas: function (canvas) {
            this.legend_canvas = canvas;
        },
        get_legend_id: function () {
            if (!this.legend_id) {
                this.legend_id = this.get_id() + "_legend";
            }
            return this.legend_id;
        },
        set_legend_visible: function (cond) {
            this.legend_visible = cond;
            if (this.legend_canvas) {
                if (cond) {
                    this.legend_canvas.removeClass('hidden');
                } else {
                    this.legend_canvas.addClass('hidden');
                }
            }
        },
        on_mouse_click: function (mouse_position) {

        },
        on_mouse_over: function (mouse_position) {

        },
        on_activate_layer_legend: function (container) {
            this.set_legend_visible(true);
            this.get_legend_canvas(container);
            this.fireEvent('layer_legend_activated', this);
        },
        on_deactivate_layer_legend: function () {
            this.set_legend_visible(false);
            this.fireEvent('layer_legend_deactivated', this);
        }
    };
};
OCS.Viewer.Functions.define_layer_legend_interface();





